import { useState } from 'react';

export default function Contact() {
  const [showSuccess, setShowSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);

    const form = e.currentTarget;
    const formData = new FormData(form);

    try {
      const response = await fetch('https://readdy.ai/api/form/d4k2mfs4bsgki10ajbo0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });

      if (response.ok) {
        setShowSuccess(true);
        form.reset();
        setTimeout(() => setShowSuccess(false), 5000);
      }
    } catch (error) {
      console.error('Form submission error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Get In Touch</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Ready to start your real estate journey? Contact us today and let's discuss how we can help you.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Contact Information */}
          <div className="space-y-6">
            <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 hover:scale-105 cursor-pointer group">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-teal-600 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-phone-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2 text-lg">Phone</h3>
                  <p className="text-gray-600">+34 674 009 683</p>
                </div>
              </div>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 hover:scale-105 cursor-pointer group">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-teal-600 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-mail-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2 text-lg">Email</h3>
                  <p className="text-gray-600">exclprojectssl@gmail.com</p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-gradient-to-br from-teal-50 to-white p-8 rounded-2xl shadow-lg">
            <form id="contact-form" data-readdy-form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  required
                  className="w-full px-5 py-3 bg-white rounded-lg border-2 border-gray-200 focus:border-teal-500 focus:outline-none transition-all text-sm shadow-lg hover:shadow-xl hover:-translate-y-0.5 duration-300"
                />
              </div>
              <div>
                <input
                  type="email"
                  name="email"
                  placeholder="Your Email"
                  required
                  className="w-full px-5 py-3 bg-white rounded-lg border-2 border-gray-200 focus:border-teal-500 focus:outline-none transition-all text-sm shadow-lg hover:shadow-xl hover:-translate-y-0.5 duration-300"
                />
              </div>
              <div>
                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone Number"
                  className="w-full px-5 py-3 bg-white rounded-lg border-2 border-gray-200 focus:border-teal-500 focus:outline-none transition-all text-sm shadow-lg hover:shadow-xl hover:-translate-y-0.5 duration-300"
                />
              </div>
              <div>
                <textarea
                  name="message"
                  placeholder="Your Message"
                  rows={5}
                  maxLength={500}
                  required
                  className="w-full px-5 py-3 bg-white rounded-lg border-2 border-gray-200 focus:border-teal-500 focus:outline-none transition-all text-sm resize-none shadow-lg hover:shadow-xl hover:-translate-y-0.5 duration-300"
                ></textarea>
              </div>
              <button
                type="submit"
                className="group relative w-full bg-gradient-to-r from-teal-600 to-teal-500 text-white py-4 rounded-lg font-semibold overflow-hidden transition-all duration-300 hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <span className="absolute inset-0 bg-gradient-to-r from-gray-800 to-gray-700 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></span>
                <span className="relative flex items-center justify-center gap-2">
                  Send Message
                  <i className="ri-send-plane-fill transform group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-300"></i>
                </span>
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Success Popup */}
      {showSuccess && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 animate-fadeIn">
          <div className="bg-white rounded-2xl p-8 max-w-md mx-4 shadow-2xl transform animate-scaleIn">
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-check-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">Message Sent!</h3>
              <p className="text-gray-600 mb-6">
                Thank you for contacting us. We'll get back to you soon.
              </p>
              <button
                onClick={() => setShowSuccess(false)}
                className="bg-gradient-to-r from-teal-600 to-teal-500 text-white px-8 py-3 rounded-lg font-semibold hover:from-gray-800 hover:to-gray-700 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
